import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

// One page failing must never blank the whole CRM: the sidebar and top bar
// stay, and the page offers a retry. Reset when the address changes.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Page crashed:', error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto mt-16 max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-red-50 text-red-600 dark:bg-red-950/40">
          <AlertTriangle className="h-6 w-6" />
        </div>
        <h2 className="text-lg font-semibold">This page hit a problem</h2>
        <p className="mt-1 text-sm text-muted-foreground">Nothing was changed. Reload to try again; the rest of the CRM still works.</p>
        <button type="button" onClick={() => window.location.reload()}
          className="mt-5 inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90">
          <RotateCcw className="h-4 w-4" />Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
